import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import s from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';

import { dialogsActions, metaActions } from '../../store/actions';
import { getDialogsItems, getIsArchiveDialogFixed } from '../../store/selectors';

import DescriptionPopup from '../DescriptionPopup';
import { ReactComponent as ArchiveIcon } from './ArchiveIcon.svg';

import { DIALOGS_DESCRIPTION_POPUP_KEY } from '../../constants/storageKeys';

const ArchiveDialogs = ({ setActiveDialog, isActive }) => {
    const dispatch = useDispatch();
    const dialogs = useSelector(getDialogsItems);
    const archiveDialog = dialogs?.filter(item => item.dialog_type_id === 0);
    const directDialogs = dialogs?.filter(item => item.dialog_type_id === 1 && !!item.expert_id &&
        (item.status_id === 1 || item.status_id === 2));
    const isArchiveDialogFixed = useSelector(getIsArchiveDialogFixed);
    const archiveWrapperRef = useRef(null);

    useEffect(() => {
        const edgeHeight = window.innerHeight - 70;
        const archiveElement = archiveWrapperRef.current;
        if (archiveElement) {
            const rect = archiveElement.getBoundingClientRect();
            const bottomPosition = rect.bottom;
            if (bottomPosition >= edgeHeight) {
                dispatch(metaActions.setArchiveDialogFixed(true));
            } else {
                dispatch(metaActions.setArchiveDialogFixed(false));
            }
        }
    }, [archiveWrapperRef.current, dialogs.length]);

    const handleArchiveDialogClick = () => {
        setActiveDialog();
        dispatch(dialogsActions.setIsArchiveCurrentDialog(true));
    };

    return (
        <div ref={archiveWrapperRef} className={cn(s.archiveWrapper,
            { [s.archiveDialogActive]: isActive, [s.archiveDialogsFixed]: isArchiveDialogFixed })}>
            <div className={s.archiveDialog} onClick={handleArchiveDialogClick}>
                <div className={s.archiveIconWrapper}>
                    <ArchiveIcon className={s.archiveIcon} />
                </div>
                <div className={s.archive}>
                    <h4 className={s.archiveHeader}>Архив</h4>
                    <div className={s.archiveDisclamerText}>Старые консультации с экспертами</div>
                </div>
            </div>

            {archiveDialog.length > 0 && directDialogs.length === 0 && <DescriptionPopup
                mainContent={'Здесь хранится история переписок'}
                storageKey={DIALOGS_DESCRIPTION_POPUP_KEY}
            />}
        </div>
    );
};

export default ArchiveDialogs;
